import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'dsp-about',
  templateUrl: 'about.container.html',
  styleUrls: [ 'about.container.scss' ]
})
export class AboutContainerComponent {
}
